import ProjectAffiliationContainer from './ProjectAffiliationContainer';

export default ProjectAffiliationContainer;
